import { useState } from "react";
import DialogComponent from "../component/base/Dialog.component";
import { TYPE } from "../utils/Utils";

export const HocPopup = (WrappedComponent) => {
  const HOC = (props) => {
    const [dialog, setDialog] = useState({
      open: false,
      bodyType: TYPE.DEFAULT,
      body: null,
      maxWidth: "md",
    });

    const setItemState = (element) => {
      if (element) {
        setDialog({
          open: element.open,
          bodyType: element.bodyType,
          body: element.body,
          title: element.title,
          maxWidth: element.maxWidth,
        });
      }
    };

    return (
      <>
        {dialog.open && (
          <DialogComponent
            open={dialog.open}
            bodyType={dialog.bodyType}
            body={dialog.body}
            title={dialog.title}
            onClose={() => setDialog({ ...dialog, open: false })}
            maxWidth={dialog.maxWidth}
          />
        )}
        <WrappedComponent {...props} dialog={setItemState} />
      </>
    );
  };
  return HOC;
};
export default HocPopup;
